/* Reviews · JS v2.8 · Dawn integration */
(function () {
  'use strict';

  function initAll(root) {
    var scope = root || document;
    formatRatingScores(scope);
    queueBadgeSync();
    var section = scope.querySelector ? scope.querySelector('#cr-reviews-section') : document.getElementById('cr-reviews-section');
    if (!section) return;

    ensureModeratedReviewForm(section);
    if (section.dataset.crInit === '1') return;
    section.dataset.crInit = '1';

    bindShowMore(section);
    bindOpenForm(section);
    bindFormStars(section);
    bindFormSubmit(section);
    bindPopupClose(section);
    bindBadgeScroll();
    if (section.dataset.displayMode === 'slider' || section.dataset.displayMode === 'slider_peek') initSlider(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
    queueBadgeSync();
  });

  document.addEventListener('shopify:section:unload', queueBadgeSync);
  document.addEventListener('shopify:section:select', queueBadgeSync);

  function queueBadgeSync() {
    syncBadgeVisibility();
    setTimeout(syncBadgeVisibility, 50);
    setTimeout(syncBadgeVisibility, 160);
  }

  function syncBadgeVisibility() {
    var hasReviewsSection = !!document.querySelector('#cr-reviews-section[data-section-type="cr-reviews"]');
    document.querySelectorAll('[data-cr-product-badge], [data-cr-badge]').forEach(function (badge) {
      badge.hidden = !hasReviewsSection;
      badge.setAttribute('aria-hidden', hasReviewsSection ? 'false' : 'true');
    });
  }

  function ensureModeratedReviewForm(section) {
    var form = section.querySelector('[data-cr-form]');
    if (!form) return;

    var text = form.querySelector('#cr-form-text');
    if (text) text.required = true;

    if (!form.querySelector('#cr-form-email')) {
      var reviewRow = text && text.closest ? text.closest('.cr-form__row') : null;
      var emailRow = document.createElement('div');
      emailRow.className = 'cr-form__row cr-form__row--email';
      emailRow.innerHTML =
        '<label class="cr-form__label" for="cr-form-email">Email</label>' +
        '<input type="email" id="cr-form-email" name="email" class="cr-form__input" placeholder="name@example.com" autocomplete="email" inputmode="email" required>' +
        '<p class="cr-form__privacy">Your email will not be displayed publicly.</p>';
      if (reviewRow) form.insertBefore(emailRow, reviewRow);
      else form.appendChild(emailRow);
    }

    if (!form.querySelector('[data-cr-form-error]')) {
      var error = document.createElement('p');
      error.className = 'cr-form__error';
      error.setAttribute('data-cr-form-error', '');
      error.hidden = true;
      var submit = form.querySelector('.cr-form__submit');
      if (submit) form.insertBefore(error, submit);
      else form.appendChild(error);
    }
  }

  function formatRatingScores(root) {
    var scope = root || document;
    var scores = scope.querySelectorAll ? scope.querySelectorAll('.cr-reviews__rating-score') : [];
    scores.forEach(function (score) {
      if (score.dataset.crFormatted === '1') return;
      var value = (score.textContent || '').trim();
      if (!value || value.indexOf('.') === -1) return;
      var parts = value.split('.');
      score.textContent = '';
      var integerPart = document.createElement('span');
      integerPart.className = 'cr-rating-int';
      integerPart.textContent = parts[0];
      var decimalPart = document.createElement('span');
      decimalPart.className = 'cr-rating-decimal';
      decimalPart.textContent = '.' + parts.slice(1).join('.');
      score.appendChild(integerPart);
      score.appendChild(decimalPart);
      score.dataset.crFormatted = '1';
    });
  }

  function bindBadgeScroll() {
    document.querySelectorAll('[data-cr-badge]').forEach(function (badge) {
      if (badge.dataset.crBadgeBound === '1') return;
      badge.dataset.crBadgeBound = '1';
      badge.addEventListener('click', function (event) {
        var target = document.getElementById('cr-reviews-section');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function bindShowMore(section) {
    var btn = section.querySelector('[data-cr-show-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      section.querySelectorAll('.cr-review--expandable').forEach(function (item) {
        item.classList.remove('cr-review--hidden');
      });
      btn.setAttribute('hidden', '');
    });
  }

  function bindOpenForm(section) {
    var openBtn = section.querySelector('[data-cr-open-form]');
    var formWrap = section.querySelector('#cr-reviews-form');
    if (!openBtn || !formWrap) return;
    openBtn.addEventListener('click', function () {
      formWrap.removeAttribute('hidden');
      formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function bindFormStars(section) {
    var stars = section.querySelectorAll('[data-cr-rating] .cr-form__star');
    if (!stars.length) return;
    stars.forEach(function (star) {
      star.addEventListener('mouseenter', function () { paintStars(stars, parseInt(star.dataset.value, 10)); });
      star.addEventListener('mouseleave', function () { paintStars(stars, parseInt(section.dataset.crSelectedRating || '0', 10)); });
      star.addEventListener('click', function () {
        var value = parseInt(star.dataset.value, 10);
        section.dataset.crSelectedRating = value;
        paintStars(stars, value);
        hideFormError(section);
      });
    });
  }

  function paintStars(stars, value) {
    stars.forEach(function (star, index) { star.classList.toggle('is-filled', index < value); });
  }

  function showFormError(section, message) {
    var error = section.querySelector('[data-cr-form-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  function hideFormError(section) {
    var error = section.querySelector('[data-cr-form-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function bindFormSubmit(section) {
    var form = section.querySelector('[data-cr-form]');
    var popup = section.querySelector('#cr-reviews-popup');
    if (!form || !popup) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideFormError(section);

      var email = form.querySelector('#cr-form-email');
      var rating = parseInt(section.dataset.crSelectedRating || '0', 10);

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!email || !email.validity.valid) {
        if (email) email.focus();
        showFormError(section, 'Enter a valid email address.');
        return;
      }

      if (rating < 1) {
        showFormError(section, 'Select a rating from 1 to 5 stars.');
        return;
      }

      /*
       * No review endpoint is connected yet. Keep the entered data in the form
       * and show an explicit status message rather than pretending it was sent.
       */
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  }

  function bindPopupClose(section) {
    var popup = section.querySelector('#cr-reviews-popup');
    if (!popup) return;
    popup.querySelectorAll('[data-cr-close-popup]').forEach(function (element) {
      element.addEventListener('click', function () {
        popup.setAttribute('hidden', '');
        document.body.style.overflow = '';
      });
    });
    if (!popup.dataset.crEscapeBound) {
      popup.dataset.crEscapeBound = '1';
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !popup.hasAttribute('hidden')) {
          popup.setAttribute('hidden', '');
          document.body.style.overflow = '';
        }
      });
    }
  }

  function initSlider(section) {
    var track = section.querySelector('[data-cr-slider]');
    var prev = section.querySelector('[data-cr-slider-prev]');
    var next = section.querySelector('[data-cr-slider-next]');
    var dots = section.querySelector('[data-cr-slider-dots]');
    if (!track) return;
    var slides = track.querySelectorAll('.cr-review');
    if (!slides.length) return;
    var isPeek = track.classList.contains('cr-reviews__grid--peek');
    var peekFrame = 0;
    var peekCenters = [];
    var peekStep = 0;
    var peekMobile = false;

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -getStep(track), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: getStep(track), behavior: 'smooth' }); });

    function measurePeek() {
      if (!isPeek) return;
      peekStep = getStep(track) || track.clientWidth || 1;
      peekCenters = Array.prototype.map.call(slides, function (slide) {
        return slide.offsetLeft + (slide.offsetWidth / 2);
      });
      peekMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    }

    function rebuildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var perView = getPerView(track);
      var pages = Math.ceil(slides.length / perView);
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cr-slider__dot';
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.dataset.page = i;
        dot.addEventListener('click', (function (page) {
          return function () { track.scrollTo({ left: getStep(track) * getPerView(track) * page, behavior: 'smooth' }); };
        })(i));
        dots.appendChild(dot);
      }
      updateSliderState();
    }

    function updateSliderState() {
      var step = isPeek && peekStep ? peekStep : getStep(track);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dots && step) {
        var page = Math.round(track.scrollLeft / (step * getPerView(track)));
        dots.querySelectorAll('.cr-slider__dot').forEach(function (dot, index) { dot.classList.toggle('is-active', index === page); });
      }
    }

    function requestPeekMotion() {
      if (!isPeek || peekFrame) return;
      peekFrame = requestAnimationFrame(function () {
        peekFrame = 0;
        updateSliderState();
        updatePeekMotion(track, slides, peekCenters, peekStep, peekMobile);
      });
    }

    if (isPeek) {
      measurePeek();
      track.addEventListener('scroll', requestPeekMotion, { passive: true });
    } else {
      track.addEventListener('scroll', updateSliderState, { passive: true });
    }

    window.addEventListener('resize', function () {
      if (isPeek) measurePeek();
      rebuildDots();
      requestPeekMotion();
    });
    rebuildDots();

    if (isPeek && slides.length > 2 && track.dataset.crPeekPositioned !== '1') {
      track.dataset.crPeekPositioned = '1';
      requestAnimationFrame(function () {
        measurePeek();
        track.scrollLeft = peekStep || getStep(track);
        requestPeekMotion();
      });
    } else if (isPeek) {
      requestPeekMotion();
    }
  }

  function updatePeekMotion(track, slides, centers, step, isMobile) {
    if (!step) return;
    var viewportCenter = track.scrollLeft + (track.clientWidth / 2);

    slides.forEach(function (slide, index) {
      var slideCenter = centers[index];
      if (typeof slideCenter !== 'number') return;
      var distance = Math.abs(slideCenter - viewportCenter) / step;
      var p = Math.min(1, distance);
      var scale = 1 - (0.46 * p);
      var lift = -28 * p;
      var opacity = 1 - (0.22 * p);

      if (isMobile) {
        scale = 1 - (0.48 * p);
        lift = -22 * p;
      }

      if (distance > 1.35) opacity = 0;

      slide.style.setProperty('--cr-peek-scale', scale.toFixed(3));
      slide.style.setProperty('--cr-peek-lift', lift.toFixed(1) + 'px');
      slide.style.setProperty('--cr-peek-opacity', opacity.toFixed(3));
      slide.style.setProperty('--cr-peek-z', String(Math.max(1, Math.round(100 - (distance * 20)))));
    });
  }

  function getStep(track) {
    var slides = track.querySelectorAll('.cr-review');
    if (slides.length > 1) {
      var offsetStep = slides[1].offsetLeft - slides[0].offsetLeft;
      if (offsetStep > 0) return offsetStep;
    }
    var slide = slides[0];
    if (!slide) return 320;
    return slide.offsetWidth + (parseFloat(window.getComputedStyle(track).gap) || 20);
  }

  function getPerView(track) {
    if (track.classList.contains('cr-reviews__grid--peek')) return 1;
    var slide = track.querySelector('.cr-review');
    if (!slide) return 1;
    return Math.max(1, Math.round(track.clientWidth / getStep(track)));
  }
})();
